import { PaginatedResultDto } from '@/Application/Pagination/PaginatedResultDto'
import { FetchAllExpedienteByUserCommand } from './FetchAllExpedienteByUserCommand'
import { ExpedienteDto } from '.'
import { UserExpedienteRepository } from '@/Domain/Expediente/UserExpedienteRepository'

export class FetchAllExpedienteByUserCommandHandler {
  private _expedienteRepository: UserExpedienteRepository
  constructor (
    expedienteRepository: UserExpedienteRepository
  ) {
    this._expedienteRepository = expedienteRepository
  }

  async handle (command: FetchAllExpedienteByUserCommand): Promise<PaginatedResultDto<ExpedienteDto>> {
    const accountId = command.accountId()
    const currentPage = command.page()
    const itemsPerPage = command.itemsPerPage()
    const pagination = { page: currentPage, itemsPerPage }
    const expedientes = await this._expedienteRepository.byUser(accountId, pagination, command.filters())
    const totalItems = await this._expedienteRepository.totalItemsByUserCount(accountId, command.filters())
    const response: ExpedienteDto[] = []
    for (const expediente of expedientes) {
      response.push(ExpedienteDto.fromExpediente(expediente))
    }
    const pages = totalItems === 0 ? 0 : Math.ceil(totalItems / itemsPerPage)
    return new PaginatedResultDto(totalItems, pages === 0 ? 0 : currentPage, pages, response)
  }
}
